/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TrashCanIcon20Light = forwardRef('TrashCanIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.5 8a.5.5 0 0 1 .5.5v6a.5.5 0 1 1-1 0v-6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M12 8.5a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0v-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1h3.5a.5.5 0 0 1 0 1h-1.125l-.962 9.746A2.5 2.5 0 0 1 12.925 18h-5.85a2.5 2.5 0 0 1-2.488-2.254L3.625 6H2.5a.5.5 0 0 1 0-1H6Zm1-1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1H7V4ZM4.63 6l.952 9.647A1.5 1.5 0 0 0 7.075 17h5.85a1.5 1.5 0 0 0 1.493-1.353L15.37 6H4.63Z" })));
});
